module.exports = __webpack_public_path__ + "img/LOGO_letter.feedae88.png";